import { createSlice, createSelector } from '@reduxjs/toolkit'
import { selectHSFiltersRaw } from './healthshelf_filter'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'



const initialState = {
    entities: {},
    status: 'idle', // idle loading success fail  
    error: null
}



const articleSlice = createSlice({
    name: 'articles',
    initialState,
    reducers: {
        articleAdd(state, action) {
            const articleData = action.payload
            state.entities[articleData.ArticleId] = articleData
        },
        articleModify(state, action) {
            const articleData = action.payload
            state.entities[articleData.ArticleId] = articleData
        } ,
        
        articleDelete(state, action) {
            const articleData = action.payload
            delete state.entities[articleData.ArticleId]
        },
        articleHydrate(state, action) {
            const articleData = action.payload
            state.entities=articleData
            state.status = 'success'
        }
    }
}) 

export const { articleAdd, articleModify, articleDelete, articleHydrate, articleBranchingLogicModify } = articleSlice.actions

export default articleSlice.reducer

const selectArticleEntities = (state) => state.articles.entities

export const selectArticles = createSelector(selectArticleEntities, (entities) =>
    Object.values(entities)
)

export const selectArticleById = (state, ArticleId) => {
    return selectArticleEntities(state)[ArticleId]
}

export const selectArticleForTopic = createSelector(
    selectArticles
    , (state, TopicId) => TopicId
    , (articles, TopicId) => {
        return articles.filter((article) => {
          return article.ComponentValues.Topics.some((x)=> {return x === TopicId})
        })
    }
)
export const selectFilteredArticles = createSelector(
    selectArticles
    , selectHSFiltersRaw
    , (articles, filters)=>{
        let newArticles = articles.filter((x) => {
            return (
                (x.ComponentValues.Topics.some((t) => { return filters.Topics.includes(t) }) || filters.Topics.length <= 0)

                && (filters.Types.includes(x.Type) || filters.Types.length <= 0)
                && (
                    ( x.Name && x.Name.toUpperCase().indexOf(filters.Search.toUpperCase())>=0)
                    || ( x.ComponentValues.LeadIn && x.ComponentValues.LeadIn.toUpperCase().indexOf(filters.Search.toUpperCase()) >=0     )
                    || ( x.ComponentValues.LeadOut && x.ComponentValues.LeadOut.toUpperCase().indexOf(filters.Search.toUpperCase())  >=0    )
                    || ( x.ComponentValues.References && x.ComponentValues.References.toUpperCase().indexOf(filters.Search.toUpperCase())>=0      )
                    || ( x.ComponentValues.Abstract && x.ComponentValues.Abstract.toUpperCase().indexOf(filters.Search.toUpperCase())   >=0   )
                    || ( x.ComponentValues.Body && x.ComponentValues.Body.toUpperCase().indexOf(filters.Search.toUpperCase())    >=0  )
                    || filters.Search ===''
                )
            )
        })


        return newArticles
    }
)